// 🔴 Bloc Visites de la fiche artisan — le RELEVÉ DE TRAVAUX du moteur `chantier/`.
//
// ⚠️ Ce fichier était un EMPLACEMENT (L2) : `chantier/` n'exposait alors aucune
// route. Il monte désormais le relevé (pages/chantier/ReleveChantier), qui
// n'appelle QUE `/api/chantier/*`.
// 🔑 Le profil de relevé est celui DÉCLARÉ par le tenant
// (`tenants.config.profil_chantier`) — ⛔ jamais deviné, ⛔ aucun slug.
// ⛔ Aucun repli sur le DAL gelé (`EnvoyerVisiteBlock`, `VisitesDuDossier`,
// `/api/visite/*`) — vérifié par `garde_frontiere_artisan.test.js`.
// 🔴 N°975 — sous un relevé consulté, « Créer le devis » (pont serveur existant),
//    INJECTÉ ici : le devis créé s'ouvre dans la vue document de la fiche.
import { useState } from "react";
import { profilChantier } from "../../../utils/tenantProfile";
import { ReleveChantier } from "../../chantier/ReleveChantier";
import { CreerDevisReleve } from "./CreerDevisReleve";
import { RouvrirReleve } from "./RouvrirReleve";
import { ListeVisitesDossier } from "./ListeVisitesDossier";

export function EmplacementVisites({ dossierId, onNavigate }) {
  // 🔴 N°1016 — après une réouverture, le relevé est RECHARGÉ (la clé change ⇒ remontage).
  const [rev, setRev] = useState(0);
  // Relevé à ouvrir en CONSULTATION (demandé par la liste) ; null ⇒ l'écran montre la visite en cours.
  const [cible, setCible] = useState(null);
  const aller = (consulter) => { setCible(consulter); setRev((x) => x + 1); };
  const ouvrir = onNavigate
    ? (d) => onNavigate("devis-document", { devisId: d.devis_id, dossierId, from: "dossier" })
    : undefined;
  return (
    <div data-testid="artisan-visites" style={{ display: "grid", gap: 8 }}>
      <div style={{ fontWeight: 500, color: "var(--oh-text)" }}>Visites</div>
      {dossierId && (
        <ListeVisitesDossier dossierId={dossierId} rev={rev}
                             onReprendre={() => aller(null)}
                             onConsulter={(v) => aller(v.id)}
                             onRouvert={() => aller(null)} />
      )}
      {dossierId
        ? <ReleveChantier key={rev} dossierId={dossierId} profilCode={profilChantier()} consulterId={cible}
                          actionsReleve={(r) => (
                            <>
                              <CreerDevisReleve releve={r} onOuvrir={ouvrir} />
                              <RouvrirReleve releve={r} dossierId={dossierId} onRouvert={() => aller(null)} />
                            </>
                          )} />
        : <p className="text-sm" style={{ color: "var(--oh-text-muted)" }}>Dossier non identifié.</p>}
    </div>
  );
}

export default EmplacementVisites;
